import { Label, Tooltip, TooltipContent, TooltipTrigger } from '@design-system';
import { Info } from 'lucide-react';

import type { ReactNode } from 'react';

interface PrefillPlanRequiredLabelProps {
  htmlFor?: string;
  children: ReactNode;
}

export function PrefillPlanRequiredLabel({ htmlFor, children }: PrefillPlanRequiredLabelProps) {
  return (
    <div className="inline-flex items-center gap-1.5 leading-snug">
      <Label
        htmlFor={htmlFor}
        className="leading-snug"
      >
        {children}
      </Label>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="Needed for client creation"
            className="focus-visible:ring-ring text-muted-foreground inline-flex size-4 shrink-0 cursor-help items-center justify-center rounded-full align-middle outline-none focus-visible:ring-2 focus-visible:ring-offset-1"
          >
            <Info
              aria-hidden="true"
              className="size-4"
            />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top">Needed for client creation</TooltipContent>
      </Tooltip>
    </div>
  );
}
